import { Component, OnInit, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GetCategoriesData, GetPercentageSeriesData, PercentageSeriesInput } from 'src/modules/empower-module/helper';
import { EmpowerModernLifeService } from 'src/services/empower-services/empower-modern-life.service';
import { EmpowerExportService } from 'src/services/empower-services/empower-export.service';
import { generateTitleDiv, NO_IMAGE, undefinedImagePath } from 'src/modules/empower-module/helper';

@Component({
  selector: 'empower-windows-oem-devices-vs-market',
  templateUrl: './windows-oem-devices-vs-market.component.html',
  styleUrls: ['./windows-oem-devices-vs-market.component.scss']
})
export class EmpowerWindowsOemDevicesVsMarketComponent implements OnInit {
  @Input() data?: any;
  _unsubscribeAll = new Subject();
  undefinedImagePath = '';

  firstChartCaption: string;
  secondChartCaption: string;
  xaxisCatgoryList: any = [];
  dataSeriesFirst: any = [];
  dataSeriesSecond: any = [];
  innerHtml = '';
  pageComment: string;

  constructor(
    public empowerModernLifeService: EmpowerModernLifeService, private empowerExportService: EmpowerExportService,
    private spinner: NgxSpinnerService,
  ) {
  }

  ngOnInit(): void {
    this.initPageData();
  }

  initPageData() {
    if (this.data) {
      this.data = JSON.parse(this.data);

      this.innerHtml = generateTitleDiv(this.data);
      this.checkPageState(this.data.pageId);
    }
  }

  checkPageState(pageId) {
    const daxReponse = this.empowerModernLifeService.getPagesState(pageId);
    this.pageComment = this.empowerModernLifeService.getPageCommentState(pageId);
    if (daxReponse && daxReponse.length) {
      this.loadVisuals(daxReponse);
    } else {
      this.executePageDaxQuery();
    }
  }

  executePageDaxQuery() {
    const payload = {
      reportId: this.data.reportId,
      pageId: this.data.pageId,
      ...this.empowerModernLifeService.getDashboardState()
    };
    this.spinner.show();
    this.empowerModernLifeService.ExecutePageDaxQuery(payload).pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
      if (response && response.length) {
        this.getDAXReponseData(response);
      } else {
        this.emitExportEvent(true);
      }
      this.spinner.hide();
    },
      err => {
        this.undefinedImagePath = undefinedImagePath;
        this.spinner.hide();
      });
  }

  getDAXReponseData(response) {
    const daxReponse = response.map(a => {
      return {
        visualId: a.visualId,
        daxResponse: a.daxResponse ? JSON.parse(a.daxResponse) : []
      }
    });
    console.log(daxReponse);
    this.setPageState(this.data.pageId, daxReponse);
    this.loadVisuals(daxReponse);
  }

  setPageState(pageId, daxData) {
    this.empowerModernLifeService.setPagesState(pageId, daxData);
  }

  loadVisuals(daxData) {
    this.loadFirstVisual(daxData[0]);
    this.loadSecondVisual(daxData[1]);
    this.emitExportEvent(true);
  }

  loadFirstVisual(visualData) {
    const seriesInput: PercentageSeriesInput = {
      daxData: visualData.daxResponse,
      orderByKey: 'dIM_DATE_COMP[FISCAL_YEAR]',
      seriesKey: 'mART_MS_O2_RCR[RCR_OEM_GROUP]',
      valueKey: '[RCR_Units___Comp_Date]'
    };
    this.xaxisCatgoryList = GetCategoriesData(seriesInput);
    this.dataSeriesFirst = GetPercentageSeriesData(seriesInput);
  }

  emitExportEvent(resolvedState: boolean) {
    setTimeout(() => {
      this.data && this.data.export && this.empowerExportService.setExportComponentSubject(6, resolvedState, this.data.pageIndex, this.data.pageTitle);
    }, 1000);
  }

  loadSecondVisual(visualData) {
    const seriesInput: PercentageSeriesInput = {
      daxData: visualData.daxResponse,
      orderByKey: 'dIM_DATE_COMP[FISCAL_YEAR]',
      seriesKey: 'mART_MS_O2_RMI[RMI_OEM_PARENT]',
      valueKey: '[Retailer_PC_Units___Comp_Date]'
    };
    this.dataSeriesSecond = GetPercentageSeriesData(seriesInput);
  }

  pageCommentChange(comment) {
    this.setPageCommentState(this.data.pageId, comment);
  }

  setPageCommentState(pageId, comment) {
    this.empowerModernLifeService.setPageCommentState(pageId, comment);
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
